// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"145":"scroll-behavior-polyfill","659":"intersection-observer","871":"tippy"}[chunkId] + ".js?" + {"145":"288f63d44d6cfdbc9856","659":"dc301f97c0cbbcaaa79c","871":"63e24758b97c20eaca37"}[chunkId] + "";
};